export default __webpack_public_path__ + "static/FKGroteskNeue-Regular-4b7621ea60512524e4432c35d37b0130.woff";